import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import useApi from 'utils/hooks/api/useApi';
import { ALERT_VARIANTS, LOCALIZATION_PAGES, API_ENDPOINTS, HTTP_VERBS } from 'utils/constants';
import { useRoot } from 'context/RootContext';

const useDeleteDiscount = id => {
  const endpoint = `${API_ENDPOINTS.DISCOUNTS}/`;
  const { t } = useTranslation(LOCALIZATION_PAGES.DISCOUNTS);
  const { showNotification } = useRoot();
  const [path, setPath] = useState(endpoint + id);
  const [{ result, loading, error }, deleteDiscount] = useApi(path, {
    initialFetch: false,
    verb: HTTP_VERBS.DELETE,
  });

  useEffect(() => {
    setPath(endpoint + id);
  }, [id, endpoint]);

  useEffect(() => {
    if (error) {
      showNotification(
        {
          message: t('discount_delete_failed'),
        },
        ALERT_VARIANTS.DANGER
      );
    }
  }, [error, showNotification, t]);

  useEffect(() => {
    if (result || result === '') {
      showNotification({
        message: t('discount_delete_success'),
      });
    }
  }, [result, showNotification, t]);

  return [{ result, loading }, deleteDiscount];
};

export default useDeleteDiscount;
